export enum PromotionStatus {
  ALL = "All",
  ACTIVE = "Active",
  SCHEDULED = "Scheduled",
  INACTIVE = "InActive",
  EXPIRED = "Expired",
  DISABLED = "Disabled",
}
